import { language as base_language } from "./base/base";
import { language as component_language } from "./components/components";
import { language as directive_language } from "./directives/directives";
import { language as module_language } from "./modules/modules";
import { language as page_language } from "./pages/pages";

//如果是通用的部份，可以直接写在这个文件里

/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 */
let language = {
    //通用部份的多语言
    ...base_language,    
    //组件的多语言
    ...component_language,
    //指令的多语言
    ...directive_language,
    //模块的多语言
    ...module_language,
    //页面的多语言
    ...page_language
};

export { language }